(() => {
  // Prevent double-init if the script is included twice
  if (window.__FreeShipTickerInit) return;
  window.__FreeShipTickerInit = true;

  const SELECTOR = "[data-free-ship-ticker]";
  const CART_JSON_URL = "/cart.js";
  const CART_ENDPOINT_RE = /\/cart\/(add|change|update|clear)\.js/i;

  let refreshTimer = null;
  const scheduleRefresh = (delay = 50) => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshAllTickers, delay);
  };

  function getCurrencyCode() {
    return (
      window?.Shopify?.currency?.active ||
      window?.Shopify?.currency?.currency ||
      document.documentElement.getAttribute("data-currency") ||
      "USD"
    );
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      try {
        return window.Shopify.formatMoney(cents);
      } catch (e) {}
    }
    const code = getCurrencyCode();
    const amount = cents / 100;
    try {
      return amount.toLocaleString(undefined, { style: "currency", currency: code });
    } catch (e) {
      return `$${amount.toFixed(2)}`;
    }
  }

  async function fetchCart() {
    const res = await fetch(CART_JSON_URL, { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed to load cart");
    return res.json();
  }

  function updateTicker(node, cart) {
    const threshold = Number(node.getAttribute("data-threshold-cents")) || 7500;
    const successText = node.getAttribute("data-success-text") || "Free shipping unlocked!";
    const awayTpl =
      node.getAttribute("data-away-text") || "You’re %AMOUNT% away from free shipping";

    const total = Number(cart?.total_price || 0);
    const remaining = Math.max(0, threshold - total);
    const pct = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 0;

    const msgEl = node.querySelector("[data-fst-msg]");
    const subEl = node.querySelector("[data-fst-sub]");
    const fillEl = node.querySelector("[data-fst-fill]");
    const barEl = node.querySelector(".free-ship-ticker__bar");

    if (fillEl) fillEl.style.width = `${pct}%`;
    if (barEl) barEl.setAttribute("aria-valuenow", String(Math.min(total, threshold)));

    if (remaining <= 0) {
      if (msgEl) msgEl.textContent = successText;
      if (subEl) subEl.textContent = "";
      node.setAttribute("data-fst-state", "unlocked");
    } else {
      const remainingText = formatMoney(remaining);
      if (msgEl) msgEl.textContent = awayTpl.replace("%AMOUNT%", remainingText);
      if (subEl) subEl.textContent = `Free shipping at ${formatMoney(threshold)}`;
      node.setAttribute("data-fst-state", "progress");
    }
  }

  async function refreshAllTickers() {
    const nodes = document.querySelectorAll(SELECTOR);
    if (!nodes.length) return;

    try {
      const cart = await fetchCart();
      nodes.forEach((node) => updateTicker(node, cart));
    } catch (err) {
      // If cart fetch fails, leave whatever is on screen (don’t reset)
      // console.warn("Free ship ticker refresh failed:", err);
    }
  }

  // 1) Initial
  document.addEventListener("DOMContentLoaded", () => scheduleRefresh(0));

  // 2) Custom hook (you can dispatch this from anywhere)
  window.addEventListener("cart:refresh", () => scheduleRefresh(0));

  // 3) Intercept fetch cart mutations
  const origFetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === "string" ? args[0] : args[0]?.url;
    const isCartCall = url && CART_ENDPOINT_RE.test(url);

    return origFetch.apply(this, args).then((res) => {
      if (isCartCall) scheduleRefresh(75);
      return res;
    });
  };

  // 4) Intercept XHR cart mutations + common "sections" cart rerenders
  const origOpen = XMLHttpRequest.prototype.open;
  const origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__fstUrl = url;
    return origOpen.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener("loadend", () => {
      const url = this.__fstUrl || "";
      const isCart =
        CART_ENDPOINT_RE.test(url) ||
        // themes often re-render cart via sections endpoint; catch those too
        (typeof url === "string" &&
          (url.includes("sections=") || url.includes("/?sections=")) &&
          (url.includes("cart") || url.includes("drawer")));
      if (isCart) scheduleRefresh(75);
    });
    return origSend.apply(this, args);
  };

  // 5) MutationObserver: if ticker markup gets re-inserted, refresh it
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.matches?.(SELECTOR) || n.querySelector?.(SELECTOR)) {
          scheduleRefresh(25);
          return;
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // 6) Also refresh when the cart drawer is opened (dialog gets [open])
  const dialogMo = new MutationObserver(() => {
    const dlg = document.querySelector("dialog.cart-drawer__dialog[open]");
    if (dlg) scheduleRefresh(0);
  });
  dialogMo.observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ["open"] });

})();